import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SearchBar = ({ searchQuery, onSearchChange, resultsCount }) => {
  return (
    <div className="relative">
      <div className="relative">
        <Input
          type="search"
          placeholder="Rechercher par titre, description ou catégorie..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="pl-10"
        />
        <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
        </div>
      </div>
      {searchQuery && (
        <div className="mt-2 text-sm text-muted-foreground">
          {resultsCount} résultat{resultsCount !== 1 ? 's' : ''} trouvé{resultsCount !== 1 ? 's' : ''}
        </div>
      )}
    </div>
  );
};

export default SearchBar;